<button
  type="button"
  class="buttonDropdown"
  [class.buttonDropdown__active]="ppActive"
  (click)="action()"
  [class.buttonDropdown__disabled]="ppDisabled"
  [disabled]="ppDisabled"
  [attr.aria-label]="ppAriaLabel || null"
>
  <div
    class="buttonDropdown__group"
    [class.buttonDropdown__group__active]="ppActive"
    [class.buttonDropdown__group__disabled]="ppDisabled"
  >
    <pp-icon
      class="buttonDropdown__icon"
      ppClass="buttonDropdown__svg"
      [ppSrc]="ppSrc"
      [ppDisplayContents]="true"
    ></pp-icon>
    <span
      class="buttonDropdown__text"
      [class.buttonDropdown__text--collapseMobile]="ppHideTextOnMobile"
    >
      <span [class.buttonDropdown__text--hide]="ppHideTextOnMobile">{{ ppText }}</span>
      <span data-testid="filtersNumber" data-test="filtersNumber">{{ ppNumber }}</span>
    </span>
  </div>
</button>
